const days = {
	0: { text: 'Sunday', value: 0 },
	1: { text: 'Monday', value: 1 },
	2: { text: 'Tuesday', value: 2 },
	3: { text: 'Wednesday', value: 3 },
	4: { text: 'Thursday', value: 4 },
	5: { text: 'Friday', value: 5 },
	6: { text: 'Saturday', value: 6 },
};
export const getPitchesDays = (pitches: any[]): any[] => {
	const items: any[] = [];
	pitches.forEach((pitch: any) => {
		if (pitch.sunFrom && pitch.sunTo) {
			items.push(days[0]);
		}
		if (pitch.monFrom && pitch.monTo) {
			items.push(days[1]);
		}
		if (pitch.tueFrom && pitch.tueTo) {
			items.push(days[2]);
		}
		if (pitch.wedFrom && pitch.wedTo) {
			items.push(days[3]);
		}
		if (pitch.thursFrom && pitch.thursTo) {
			items.push(days[4]);
		}
		if (pitch.friFrom && pitch.friTo) {
			items.push(days[5]);
		}
		if (pitch.satFrom && pitch.satTo) {
			items.push(days[6]);
		}
	});
	return items;
};
